module.exports = __webpack_public_path__ + "static/media/014.dc4c2528.jpg";